/**
 * Tipos TypeScript para o módulo de Notificações
 * Compatíveis com os DTOs do backend
 */

import { MarketIndicatorsNotificationMetadata } from '../indicators/marketIndicatorProposals/types';
import { WhatsappFuelDistributorQuoteNotificationMetadata } from '../quotes/distributors/whatsappQuoteDrafts/types';

export interface MyStationFlagsPendingNotificationMetadata {
  kind: 'my_station_flags_pending';
  weekId?: string;
  deepLink: string;
  pendingCount?: number;
}

export type NotificationMetadata =
  | MarketIndicatorsNotificationMetadata
  | WhatsappFuelDistributorQuoteNotificationMetadata
  | MyStationFlagsPendingNotificationMetadata
  | Record<string, unknown>;

export enum NotificationType {
  INFO = 'INFO',
  WARNING = 'WARNING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export interface INotificationResponse {
  id: string;
  isGlobal: boolean;
  title: string;
  message: string;
  type: NotificationType;
  expiresAt: Date | null;
  readAt: Date | null;
  feedback: string | null;
  createdAt: Date;
  updatedAt: Date;
  userIds?: string[];
  customerIds?: string[];
  recipientReadAt?: Record<string, string | null>;
  /** Opcional: indica se o usuário logado pode editar (somente admin). Ver frontend-notifications-edit-permission-guide.md */
  canEdit?: boolean;
  /** Opcional: ID do usuário que criou a notificação (auditoria). */
  createdById?: string | null;
  /** @deprecated Use isGlobal / userIds */
  userId?: string | null;
  /** @deprecated Use customerIds */
  customerId?: string | null;
  /** Metadados opcionais para ações de navegação (ex.: lote de indicadores, cotação WhatsApp). */
  metadata?: NotificationMetadata;
  /** Timestamp ISO do primeiro admin que abriu a revisão (team acknowledge). */
  acknowledgedAt?: string | null;
  /** UUID do admin que abriu primeiro ou null. */
  acknowledgedBy?: string | null;
  /** true quando acknowledgedAt != null */
  isTeamAcknowledged?: boolean;
}

export interface ITeamAcknowledgeRequest {
  batchId?: string;
  draftId?: string;
  weekId?: string;
}

export type ITeamAcknowledgeResponse = INotificationResponse;

export interface ICreateNotificationRequest {
  userIds?: string[];
  customerIds?: string[];
  isGlobal?: boolean;
  title: string;
  message: string;
  type: NotificationType;
  expiresAt?: string | null;
}

export interface IUpdateNotificationRequest {
  userIds?: string[];
  customerIds?: string[];
  isGlobal?: boolean;
  title?: string;
  message?: string;
  type?: NotificationType;
  expiresAt?: string | null;
}

export interface ICreateNotificationReadRequest {
  feedback?: string;
}

export interface IUpdateNotificationReadRequest {
  read?: boolean;
  readAt?: string;
  feedback?: string;
}

/** user = do usuário logado; all = todas (apenas admin) */
export enum NotificationScope {
  USER = 'user',
  ALL = 'all',
}

/** @deprecated Preferir NotificationScope */
export type NotificationQueryScope = 'user' | 'all';

export interface IQueryNotificationParams {
  page?: number;
  limit?: number;
  read?: boolean;
  type?: NotificationType;
  orderBy?: 'createdAt' | 'readAt';
  order?: 'ASC' | 'DESC';
  scope?: NotificationScope;
}

export interface IPaginationMeta {
  totalItems: number;
  itemCount: number;
  itemsPerPage: number;
  totalPages: number;
  currentPage: number;
}

export interface INotificationsPagedResponse {
  items: INotificationResponse[];
  meta: IPaginationMeta;
}

export interface INotificationCountResponse {
  count: number;
}

export interface IMarkAllReadResponse {
  updated: number;
  message: string;
}

export interface INotificationReadResponse {
  id: string;
  read: boolean;
  readAt: Date | null;
  feedback: string | null;
}
